// @ts-nocheck
import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export const dispatchResetState: Handler = props => {
    props.dispatch({
        type: "Greif/Pages/ContactUs/ClearForm",
    });
};

export const chain = [dispatchResetState];
const resetState = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetState");
export default resetState;
